import React, { useState, useEffect } from "react";
import Countdown from "react-countdown";
import CountDownComponent from "../../components/CountDownComponent";
import { countDownEndTime, showCountDown } from "../../config/themeConfig";
import { landingPageData } from "../../config/dataConfig";
import { mailChimpUrl } from "../../config/themeConfig";
import AboutUsModal from "../../components/AboutUsModal";
import ContactUsModal from "../../components/ContactUsModal";
import SubscribeForm from "../../components/SubscribeForm";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { Helmet } from "react-helmet";
import "../../../src/App.scss";


const ImageBackground1 = () => {
  const [activeModal, setActiveModal] = useState("home"); // "home", "about", "contact"
  useEffect(() => {
    const handleAboutShow = () => setActiveModal("about");
    const handleContactShow = () => setActiveModal("contact");
    const handleModalHide = () => setActiveModal("home");
    const aboutModal = document.getElementById("about");
    const contactModal = document.getElementById("contact");
    aboutModal?.addEventListener("show.bs.modal", handleAboutShow);
    contactModal?.addEventListener("show.bs.modal", handleContactShow);
    aboutModal?.addEventListener("hidden.bs.modal", handleModalHide);
    contactModal?.addEventListener("hidden.bs.modal", handleModalHide);
    return () => {
      aboutModal?.removeEventListener("show.bs.modal", handleAboutShow);
      contactModal?.removeEventListener("show.bs.modal", handleContactShow);
      aboutModal?.removeEventListener("hidden.bs.modal", handleModalHide);
      contactModal?.removeEventListener("hidden.bs.modal", handleModalHide);
    };
  }, []);

    useEffect(() => {
    const handleModalScrollFix = () => {
      if (document.body.classList.contains("modal-open")) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = "0px";
      } else {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };

    const observer = new MutationObserver(handleModalScrollFix);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);


  
  return (
    <div id="main-wrapper">

      <Helmet>
        <title>
          {activeModal === "about"
            ? "About 70mm Entertainments | Our Story & Vision"
            : activeModal === "contact"
              ? "Contact 70mm Entertainments | Get in Touch"
              : "70mm Entertainments | Creative Film Production House"}
        </title>

        <meta
          name="description"
          content={
            activeModal === "about"
              ? "Learn about 70mm Entertainments — our mission, vision, and journey as a top film production company bringing ideas to life on screen."
              : activeModal === "contact"
                ? "Contact 70mm Entertainments — reach out to our team for collaborations, partnerships, or inquiries about our film production services."
                : "70mm Entertainments is a premier film production company specializing in innovative storytelling, high-quality filmmaking, and content creation for global audiences."
          }
        />

        <meta
          name="keywords"
          content={
            activeModal === "about"
              ? "70mm Entertainments, about 70mm, film production company, media company, creative vision, filmmaking"
              : activeModal === "contact"
                ? "70mm Entertainments contact, film production contact, media house contact, collaborate with 70mm, film inquiries"
                : "70mm Entertainments, film production, movie production, creative storytelling, Indian film company, media house"
          }
        />

        <meta name="author" content="70mm Entertainments" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content={
            activeModal === "about"
              ? "About 70mm Entertainments | Our Story & Vision"
              : activeModal === "contact"
                ? "Contact 70mm Entertainments | Get in Touch"
                : "70mm Entertainments | Creative Film Production House"
          }
        />
        <meta
          property="og:description"
          content={
            activeModal === "about"
              ? "Discover the vision and mission behind 70mm Entertainments."
              : activeModal === "contact"
                ? "Reach out to 70mm Entertainments for partnerships, collaborations, or service inquiries."
                : "Discover 70mm Entertainments — a leader in film production and creative storytelling."
          }
        />
        <meta
          property="og:url"
          content={
            activeModal === "about"
              ? "https://www.70mmentertainments.com/about"
              : activeModal === "contact"
                ? "https://www.70mmentertainments.com/contact"
                : "https://www.70mmentertainments.com/"
          }
        />
        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={
            activeModal === "about"
              ? "About 70mm Entertainments | Our Story & Vision"
              : activeModal === "contact"
                ? "Contact 70mm Entertainments | Get in Touch"
                : "70mm Entertainments | Creative Film Production House"
          }
        />
        <meta
          name="twitter:description"
          content={
            activeModal === "about"
              ? "Learn more about 70mm Entertainments, our story, and our passion for filmmaking."
              : activeModal === "contact"
                ? "Get in touch with 70mm Entertainments for your film production needs."
                : "Innovative film production and storytelling by 70mm Entertainments."
          }
        />
      </Helmet>

      <header id="header">
        <nav className="primary-menu navbar navbar-expand-md navbar-text-light bg-transparent border-bottom-0">
          <div className="container position-relative">
            <div className="col-auto col-lg-2">
              {/* Logo */}
              <a className="logo" href="index.html" title="70MM">
                {" "}
                <img src="images/70mm Revised Logo white.png" alt="70mm" style={{ width: "160px", marginTop: "10px" }} />{" "}
              </a>
              {/* Logo End */}
            </div>
            <div className="col col-lg-8 navbar-accordion px-0">
              <button
                className="navbar-toggler ms-auto"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#header-nav"
              >
                <span />
                <span />
                <span />
              </button>
              <div style={{ marginBottom: "30px" }}
                id="header-nav"
                className="collapse navbar-collapse justify-content-center"
              >
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="modal"
                      data-bs-target="#about"
                      href="/"
                      style={{ textDecoration: "none" }}
                    >
                      About Us
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="modal"
                      data-bs-target="#contact"
                      href="/"
                      style={{ textDecoration: "none" }}
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-auto col-lg-2 d-flex justify-content-end">
              {/* <ul className="social-icons social-icons-light">
                {socialMediaData.length > 0 &&
                  socialMediaData.map((value, index) => (
                    <li className={value.class} key={index}>
                      <Tooltip text={value.name} placement="top">
                        <a
                          data-bs-toggle="tooltip"
                          href={value.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={value.name}
                        >
                          <i className={value.icon} />
                        </a>
                      </Tooltip>
                    </li>
                  ))}
              </ul> */}
            </div>
          </div>
        </nav>
        {/* Navbar End */}
      </header>
      {/* Header End */}
      <div className="container-fluid px-0">
        <section className="hero-wrap">
          <div className="hero-mask opacity-8 bg-dark" />
          <div
            className="hero-bg"
            style={{ backgroundImage: 'url("./images/intro-bg.jpg")' }}
          />
          <div className="hero-content min-vh-100 d-flex flex-column">
            <div className="container py-5 px-4 px-lg-5 my-auto">
              <div className="row py-5 py-sm-4">
                {showCountDown && (
                  <div className="col-auto text-white text-center mx-auto mb-4 pb-2">
                    <Countdown
                      zeroPadTime={3}
                      date={countDownEndTime}
                      renderer={CountDownComponent}
                    ></Countdown>
                  </div>
                )}
                <div className="col-12 text-center mx-auto">
                  <h1 className="text-9 text-white d-inline-block fw-700 rounded px-3 py-2 mb-4 c-s">
                    {landingPageData.coming_soon}
                  </h1>
                  <h2 className="text-15 fw-600 text-white mb-4">
                    {landingPageData.heading}
                  </h2>
                </div>
                <div className="col-md-8 col-lg-6 col-xl-5 mx-auto text-center">
                  <p className="text-5 text-light mb-3">
                    {landingPageData.notify.text}
                  </p>
                  <MailchimpSubscribe
                    url={mailChimpUrl}
                    render={({ subscribe, status, message }) => (
                      <SubscribeForm
                        subscribe={subscribe}
                        status={status}
                        message={message}
                      ></SubscribeForm>
                    )}
                  />

                </div>
              </div>
            </div>
           
            <footer className="container text-center">
              <p className="text-light text-2 mb-2">
                Copyright © 2025{" "}
                <a className="fw-600" href="/" style={{ color: "rgb(190, 30, 46)" }}>
                  70MM Entertainments
                </a>
                . All Rights Reserved.
              </p>
            </footer>
          </div>
        </section>
      </div>
      <AboutUsModal />
      <ContactUsModal />
      

    </div>
  );
};

export default ImageBackground1;
